import { FunctionComponent, useCallback } from 'react'
import styled, { css } from 'styled-components'
import { printCSS } from '@utils/style'
import { useQueryClient } from '@tanstack/react-query'
import useTracking, { TrackingFnType } from '@hooks/useTracking'
import { stripHtml } from '@hooks/useTracking/utils'
import { scrollToCommentingWidget } from '@widgets/Commenting/utils'
import useCommentsNumber from '@hooks/useCommentsNumber'
import LabelWrapper from '@components/Social/LabelWrapper'
import translate from '@i18n'
import PrimaryCTAButton from '@components/Buttons/PrimaryCTAButton'

const StyledPrimaryCTAButton = styled(PrimaryCTAButton)`
  ${printCSS(css`
    display: none;
  `)}
`

const CommentButton: FunctionComponent = () => {
  const queryClient = useQueryClient()
  const commentsNumber = useCommentsNumber()

  const articleClickShowCommentHandler = useCallback<TrackingFnType>(
    ({ pageMetadata }) => ({
      event: 'article_show_comments',
      eventCategory: 'article',
      eventAction: 'show_comments',
      eventLabel: `${pageMetadata.id}:${stripHtml(pageMetadata.title)}`,
    }),
    []
  )

  const handleArticleClickShowCommentTracking = useTracking(
    articleClickShowCommentHandler
  )

  const handleClick = useCallback(() => {
    handleArticleClickShowCommentTracking()
    scrollToCommentingWidget(queryClient)
  }, [handleArticleClickShowCommentTracking, queryClient])

  return (
    <LabelWrapper labelText={translate('article.sharing.comment')}>
      <StyledPrimaryCTAButton
        size="small"
        iconName="message-lines"
        iconLeft={true}
        onClick={handleClick}>
        {commentsNumber}
      </StyledPrimaryCTAButton>
    </LabelWrapper>
  )
}

export default CommentButton
